// extracted by mini-css-extract-plugin
export default {"socialMediaLinkListContainer":"socialMediaLinkListContainer__xra_V","content":"content__a14PV","caption":"caption__u7GRN","toggle":"toggle___xLB2","open":"open__qFs_t","closed":"closed__IEuOq"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"socialMediaLinkListContainer\":\"socialMediaLinkListContainer__xra_V\",\"content\":\"content__a14PV\",\"caption\":\"caption__u7GRN\",\"toggle\":\"toggle___xLB2\",\"open\":\"open__qFs_t\",\"closed\":\"closed__IEuOq\"}";
        // 1787130556865
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  